export default __webpack_public_path__ + "static/media/2424.8d77ca23.png";